import { useContext } from 'react';
import WizardContext from "./WizardContext.js";
/**
 * @memberof UIWizard
 * @function useWizard
 * @returns {import('./WizardContext.js').TWizardContext}
 */
export default function useWizard() {
  const context = useContext(WizardContext);
  if (!context) {
    throw Error('Wrap your step with a `Wizard` component');
  } else {
    return context;
  }
}